module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_poi_map.04dca778.svg";